import { NgModule } from '@angular/core';
import { DropdownInputPipe } from './dropdown-input.pipe';

@NgModule({
  declarations: [DropdownInputPipe],
  imports: [],
  exports: [DropdownInputPipe]
})
export class DropdownInputModule {}
